// extracted by mini-css-extract-plugin
export var currencyInput = "_mn-1";
export var currencySymbol = "_mn-0";